export default __webpack_public_path__ + "static/media/41t.e51cadb3.jpg";